import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  selectRecommended(event) {
    const select = event.target.checked
    this.element.querySelectorAll('[data-recommended="true"]').forEach(checkbox => {
      checkbox.checked = select
      checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
